import { onBeforeUnmount, onMounted, ref } from 'vue';

// True from the 'medium' breakpoint up - the same boundary structure.scss splits
// .mobile_only / .mobile_hidden on, and the one select_field.scss swaps the native
// picker for the custom popover at.
//
// The width is read from --breakpoint-medium, which root.scss emits on :root from
// App\Enums\Breakpoint, so the value is not re-typed in JS. The literal below is
// that same value, kept only for the window where the stylesheet has not applied
// yet: the CSS ships from a different Vite entry to this one, so its arrival is not
// ordered against ours. Keep it in step with the enum.
const FALLBACK_WIDTH = '768px';

// matchMedia rather than a resize handler: one listener, firing only as the
// boundary is crossed. A value left stale after a device rotation is the failure
// mode this exists to avoid.
export function useIsDesktop() {
    const width = getComputedStyle(document.documentElement)
        .getPropertyValue('--breakpoint-medium')
        .trim();

    const query = window.matchMedia(`(min-width: ${width || FALLBACK_WIDTH})`);
    const isDesktop = ref(query.matches);

    function onChange(event) {
        isDesktop.value = event.matches;
    }

    onMounted(() => query.addEventListener('change', onChange));
    onBeforeUnmount(() => query.removeEventListener('change', onChange));

    return isDesktop;
}
